const SDK_URL = "https://checkout.razorpay.com/v1/checkout.js";
let sdkPromise;

export function loadRazorpay() {
  if (typeof window === "undefined") return Promise.reject(new Error("No window"));
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SDK_URL;
      s.async = true;
      s.onload = () => (window.Razorpay ? resolve(window.Razorpay) : reject(new Error("Razorpay unavailable")));
      s.onerror = () => {
        sdkPromise = null;
        reject(new Error("Could not load the payment window. Check your connection and try again."));
      };
      document.head.appendChild(s);
    });
  }
  return sdkPromise;
}

// Opens the modal and settles with the Razorpay success payload, or rejects
// with { dismissed: true } if the user closes it / { message } on failure.
export async function openRazorpay(options) {
  const Razorpay = await loadRazorpay();
  return new Promise((resolve, reject) => {
    const rzp = new Razorpay({
      ...options,
      handler: resolve,
      modal: { ondismiss: () => reject({ dismissed: true }) },
    });
    rzp.on?.("payment.failed", (r) =>
      reject({ message: r?.error?.description || "Payment failed. Please try again." })
    );
    rzp.open();
  });
}
